function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import classnames from 'classnames';

/**
 * Status: *in progress*.
 * Category: Loader
 *
 * Future work: Replace it with gif
 *
 */
var Spinner = function Spinner(_ref) {
  var _classnames;

  var className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'lg' : _ref$type;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('spinner', (_classnames = {}, _defineProperty(_classnames, className, className), _defineProperty(_classnames, "spinner--".concat(type), type), _classnames))
  }, /*#__PURE__*/React.createElement("div", {
    className: "spinner__blade spinner__blade--0"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spinner__blade spinner__blade--1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spinner__blade spinner__blade--2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spinner__blade spinner__blade--3"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spinner__blade spinner__blade--4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spinner__blade spinner__blade--5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spinner__blade spinner__blade--6"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spinner__blade spinner__blade--7"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spinner__blade spinner__blade--8"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spinner__blade spinner__blade--9"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spinner__blade spinner__blade--10"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spinner__blade spinner__blade--11"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spinner__blade spinner__blade--12"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spinner__blade spinner__blade--13"
  }));
};

export default Spinner;